/**
 * Utilitários de sessão (JWT no cliente — apenas leitura de exp, sem validar assinatura).
 * A validação real continua na API.
 */

function decodeJwtPayload(token) {
  if (token == null || typeof token !== "string") return null;
  const trimmed = token.trim();
  if (!trimmed) return null;
  try {
    const parts = trimmed.split(".");
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/** Retorna true se o token estiver ausente, inválido ou com exp no passado (com folga de skew). */
export function isAccessTokenExpired(token, skewSeconds = 60) {
  if (!token || typeof token !== "string" || !token.trim()) return true;
  const payload = decodeJwtPayload(token);
  if (!payload) return true;
  if (payload.exp == null) return false;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp <= now + skewSeconds;
}

/** Data de expiração do token ou null. */
export function getAccessTokenExpiryDate(token) {
  const payload = decodeJwtPayload(token);
  if (!payload || payload.exp == null) return null;
  return new Date(payload.exp * 1000);
}
